"use strict";
angular.module("internal.exams").controller("InternalExamSkill", ["$scope",
    "$state",
    "$stateParams",
    "EXSkill",
    "EXSkillCategory",
    "EXSkillOption",
    "$window",
    function ($scope, $state, $stateParams, EXSkill, EXSkillCategory, EXSkillOption, $window) {
        $scope.Skill = {
            active_status: true,
            critical: true
        };
        $scope.SkillOptions = [];
        $scope.pointsPossible = 0;
        $scope.addAnotherSkillBool = false;
        $scope.saveMessage = $stateParams.saveMessage;
        $scope.DisabledInstructions = "";
        $window.scrollTo(0, 0);
        if ($stateParams.examSkillID != null) {
            EXSkill.getskill($stateParams.examSkillID).then(function (Skill) {
                $scope.Skill = Skill;
                if (Skill.fbusecount > 0) {
                    $scope.DisabledInstructions = "This skill is being used on one or more forms. Remove it from all forms to allow inactive.";
                    $scope.SaveWarning = "This skill is being used on one or more forms. Updating this skill will apply to all forms and may change historical representations.";
                }
            });
            EXSkillOption.getskilloptions($stateParams.examSkillID).then(function (SkillOptions) {
                $scope.SkillOptions = SkillOptions;
                $scope.changePointsPossible();
            });
        }
        EXSkillCategory.get().then(function (SkillCategories) {
            $scope.CategoryOptions = SkillCategories;
        });
        $scope.addAnotherSkill = function () {
            EXSkill.save($scope.Skill, $scope.SkillOptions).then(function (Skill) {
                $scope.saving = false;
                if (Skill != null) {
                    $state.go("internal.exams.administrative.skill", { examSkillID: null, saveMessage: "Record updated successfully" });
                } else {
                    $scope.saveMessage = "Error: Save failed";
                    $window.scrollTo(0, 0);
                }
            });
        };
        $scope.save = function () {
            $scope.saving = true;
            EXSkill.save($scope.Skill, $scope.SkillOptions).then(function (Skill) {
                $scope.saving = false;
                if (Skill != null) {
                    $state.go("internal.exams.administrative.skill", { examSkillID: Skill.id, saveMessage: "Record updated successfully" });
                } else {
                    $scope.saveMessage = "Error: Save failed";
                    $window.scrollTo(0, 0);
                }
            });
        };
        $scope.delete = function () {
            if ($scope.Skill.fbusecount != null && $scope.Skill.fbusecount > 0) {
                $scope.saveMessage = "The skill is already used in an Exam form. Please set this to inactive to prevent future usage.";
                $window.scrollTo(0, 0);
            } else {
                $scope.deleting = true;
                if (window.confirm("Are you sure you want to delete this skill category?")) {
                    EXSkill.delete($scope.Skill.id).then(function () {
                        $scope.deleting = false;
                        $state.go("internal.exams.administrative.skills", {}, {
                            reload: "internal.exams.administrative.skills"
                        });
                    });
                } else {
                    $scope.deleting = false;
                }
            }
        };
        $scope.copy = function () {
            $scope.copying = true;
            EXSkill.save($scope.Skill, $scope.SkillOptions).then(function (Skill) {
                if (Skill != null) {
                    var copiedSkill = angular.copy($scope.Skill);
                    var copiedSkillOptions = angular.copy($scope.SkillOptions);
                    delete copiedSkill.id;
                    copiedSkillOptions.forEach(function (skillOpt) {
                        delete skillOpt.id;
                    })
                    copiedSkill.name = "Copy of " + copiedSkill.name;
                    EXSkill.save(copiedSkill, copiedSkillOptions).then(function (CopiedSkill) {
                        $state.go("internal.exams.administrative.skill", {
                            examSkillID: CopiedSkill.id
                        });
                        $scope.addAnotherSkillBool = false;
                    });
                } else {
                    $scope.saveMessage = "Error: Save failed";
                    $window.scrollTo(0, 0);
                }
            });
            $scope.copying = false;
        };
        $scope.addOption = function () {
            var result = $scope.SkillOptions.map(function (a) { return a.sort_order; });
            var sortOrder = result.length > 0 ? Math.max.apply(null, result) + 1 : 1

            $scope.SkillOptions.push({
                points: 0,
                sort_order: sortOrder
            });
        };
        $scope.removeOption = function (option) {
            $scope.SkillOptions.splice($scope.SkillOptions.indexOf(option), 1);
        };
        $scope.changePointsPossible = function () {
            var x;
            $scope.pointsPossible = 0;
            for (x in $scope.SkillOptions) {
                $scope.pointsPossible += $scope.SkillOptions[x].points;
            }
        };
    }]);